import { useQueries } from "@tanstack/react-query"
import InboundMemberPaymentsClient from "../pages/inbound-member-payments/lib/InboundMemberPaymentsClient"
import { HttpErrors } from "#/utils/HttpErrors"
import { useAuthentication } from "#/components/context/authentication/AuthenticationProvider"

const client = new InboundMemberPaymentsClient()

export const useInvoices = (expenseIds: number[]) => {
  const { handleSessionExpiration } = useAuthentication()

  const invoices = useQueries({
    queries: expenseIds.map((expenseId) => ({
      queryKey: ["invoices", expenseId],
      queryFn: async () => {
        try {
          return await client.getInvoices(expenseId.toString())
        } catch (error) {
          if (error.name === HttpErrors.UNAUTHORIZED) {
            handleSessionExpiration()
          }
          throw error
        }
      },
      enabled: Boolean(expenseId),
      refetchOnWindowFocus: true
    }))
  })
  return invoices
}

// Re-export the Invoice type from the client
export type { Invoice } from "../pages/inbound-member-payments/lib/InboundMemberPaymentsClient"
